import { DEFAULT_RULES, type RulesConfig } from '../engine';

/** House-rules controls, shared by hot-seat setup and the online lobby. */
export function RulesForm({ rules, onChange }: { rules: RulesConfig; onChange: (r: RulesConfig) => void }) {
  return (
    <details>
      <summary>House rules</summary>
      <label class="row">
        <span>Play to</span>
        <input
          type="number"
          min={10}
          max={500}
          value={rules.targetScore}
          data-testid="target"
          onInput={(e) => onChange({ ...rules, targetScore: Number((e.target as HTMLInputElement).value) || DEFAULT_RULES.targetScore })}
        />
      </label>
      <label class="row">
        <span>Minimum bid</span>
        <input
          type="number"
          min={1}
          max={12}
          value={rules.minBid}
          onInput={(e) => onChange({ ...rules, minBid: Number((e.target as HTMLInputElement).value) || DEFAULT_RULES.minBid })}
        />
      </label>
      <label class="row">
        <span>Kitty</span>
        <select
          value={String(rules.kittySize)}
          onChange={(e) => {
            const v = (e.target as HTMLSelectElement).value;
            onChange({ ...rules, kittySize: v === 'auto' ? 'auto' : Number(v) });
          }}
        >
          <option value="auto">Auto (4–6)</option>
          <option value="4">About 4</option>
          <option value="5">About 5</option>
          <option value="6">About 6</option>
        </select>
      </label>
      <label class="row">
        <input
          type="checkbox"
          checked={rules.partnerWithThree}
          onChange={(e) => onChange({ ...rules, partnerWithThree: (e.target as HTMLInputElement).checked })}
        />
        <span>Call a partner with 3 players</span>
      </label>
    </details>
  );
}
